import { Outlet } from "react-router-dom";
import { NvGnb } from "@/components/navigator";
import { useAuth } from "@/contexts/auth-context";
import { gnbTypeOf } from "@/lib/access";

/**
 * Layout used ONLY by the chat page.
 * Header is rendered for navigation/identity, but the footer is intentionally
 * omitted so the chat UI can occupy the full viewport.
 */
export const ChatLayout = () => {
  const { user, accessLevel, logout } = useAuth();
  return (
    <div className="flex h-dvh flex-col overflow-hidden bg-nv-surface font-sans text-nv-text-primary">
      <NvGnb
        userType={gnbTypeOf(accessLevel)}
        userName={user?.requester_name}
        onLogout={logout}
        className="shrink-0 max-lg:h-auto max-lg:[&>div]:flex-wrap max-lg:[&>div]:gap-3 max-lg:[&>div]:px-4 max-lg:[&>div]:py-3 max-lg:[&_nav]:order-3 max-lg:[&_nav]:w-full max-lg:[&_nav]:justify-between max-lg:[&_nav]:gap-4"
      />
      <main className="flex min-h-0 flex-1 flex-col">
        <Outlet />
      </main>
    </div>
  );
};
